
const env = {
  app: null,
  bootTime: new Date()
}

export default env


// WEBPACK FOOTER //
// ./src/env.js